import React from "react";
import PropTypes from "prop-types";
import { useTheme } from "@material-ui/core/styles";
import { Grid, Box } from "@material-ui/core";
import SrTitle from "../SrTitle";
import Typography from "../Typography";

const SrContentHeader = ({ title, actions, subTitle }) => {
  const theme = useTheme();

  return (
    <Grid container item justifyContent="space-between">
      <Grid item>
        <Grid item xs={12} md="auto">
          <Box marginBottom={theme.spacing(0.2)}>
            <SrTitle>{title}</SrTitle>
            {subTitle && (
              <Typography variant="subtitle1">{subTitle}</Typography>
            )}
          </Box>
        </Grid>
      </Grid>
      {actions && (
        <Grid item xs={12} md="auto">
          <Box display="flex" flexGrow={1}>
            {actions}
          </Box>
        </Grid>
      )}
    </Grid>
  );
};

SrContentHeader.propTypes = {
  title: PropTypes.node.isRequired,
  actions: PropTypes.element,
  subTitle: PropTypes.node,
};

SrContentHeader.defaultProps = {
  actions: null,
  subTitle: "",
};

export default SrContentHeader;
